<section class="bg-surface-0 dark:bg-surface-950 p-12 lg:p-20">
	<div class="flex flex-col items-center gap-8">
		<div class="flex flex-col items-center gap-4">
			<app-headline-large [title]="content.title"></app-headline-large>
		</div>

		<div class="w-full">
			<p-accordion
				expandIcon="pi pi-chevron-down"
				collapseIcon="pi pi-chevron-up"
				class="space-y-0!">
				@for (item of content.copy; track item.title; let index = $index) {
				<p-accordion-panel [value]="index.toString()">
					<p-accordion-header
						class="hover:bg-primary-50! px-4! py-4! text-base! font-semibold! text-surface-800! dark:text-surface-0! leading-tight!">
						<h3>{{ item.title }}</h3>
					</p-accordion-header>
					<p-accordion-content>
						<app-body-large
							[description]="item.description"
							class="px-4!"></app-body-large>
					</p-accordion-content>
				</p-accordion-panel>
				}
			</p-accordion>
		</div>

		<div
			class="w-full flex flex-col items-center gap-8 p-8 bg-primary-500 dark:bg-surface-900 border border-surface-200 dark:border-surface-700 shadow-md">
			<div class="flex flex-col items-center gap-2">
				<h2 class="text-2xl font-medium text-surface-0 dark:text-surface-0 leading-tight">{{content.description}}</h2>
				<p class="text-base text-surface-0 dark:text-surface-0/70 leading-normal">
					Monday to Friday 5:00AM - 6:30PM PT or Saturday & Sunday 5:00AM - 6:00PM PT
				</p>
			</div>

			<app-call-us-button bgColor="dark"></app-call-us-button>
		</div>
	</div>
</section>
